import { useMemo, useState } from "react";

export interface UseShowMoreLessResult<T> {
  visibleItems: T[];
  isExpanded: boolean;
  toggleExpanded: () => void;
  hasMore: boolean;
}

export function useShowMoreLess<T>(
  items: T[],
  initialCount: number,
): UseShowMoreLessResult<T> {
  const [isExpanded, setIsExpanded] = useState(false);

  const result = useMemo(() => {
    const hasMore = items.length > initialCount;
    const visibleItems = isExpanded ? items : items.slice(0, initialCount);

    return { visibleItems, isExpanded, hasMore };
  }, [items, initialCount, isExpanded]);

  const toggleExpanded = () => setIsExpanded(!isExpanded);

  return { ...result, toggleExpanded };
}
